import React from 'react';
import { ChatWidgetTheme } from '../types';

/**
 * Ícone SVG default para o botão flutuante (MessageCircle)
 */
const DefaultWidgetIcon = React.createElement(
  'svg',
  {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  },
  React.createElement('path', {
    d: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  })
);

/**
 * Tema padrão do widget baseado nas especificações fornecidas
 */
export const defaultTheme: ChatWidgetTheme = {
  general: {
    title: 'Widget Preview',
    subtitle: 'Powered by Meerkat Coding',
    placeholder: 'Type your question...',
    initialMessage: 'How can I assist you today?',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    widgetIcon: DefaultWidgetIcon,
    iconSize: '24px',
    iconPadding: '0',
  },

  colors: {
    // Cabeçalho
    headerBackground: '#111827',
    headerText: '#f9fafb',

    // Mensagens do usuário
    messageUserBackground: '#4f46e5',
    messageUserText: '#ffffff',

    // Mensagens do bot
    messageBotBackground: '#ffffff',
    messageBotText: '#111827',

    // Input e botões
    inputBackground: '#ffffff',
    inputBorder: '#e5e7eb',
    buttonBackground: '#4f46e5',
    buttonText: '#ffffff',

    // Backgrounds
    lightBackground: '#f6f7fb',
    lightShade50: '#eceff5',
    lightShade100: '#cfd5e1',

    // Indicadores e estados
    typingBackground: '#ffffff',
    typingIndicator: '#4b5563',
    disabledText: '#9aa3b2',

    // Toggle (se aplicável)
    toggleBackground: '#4f46e5',
    toggleActiveBackground: '#3730a3',
    toggleHover: '#4338ca',
    toggleIconStroke: '#ffffff',
    toggleIconFill: 'none',
  },

  layout: {
    // Dimensões responsivas
    windowWidth: 'min(420px, calc(100vw - 40px))',
    windowHeight: 'min(600px, calc(100vh - 100px))',

    // Bordas
    borderRadius: '0.75rem',
    messageBorderRadius: '0.75rem',
    toggleBorderRadius: '0.75rem',

    // Espaçamentos
    spacing: '0.875rem',
    headerPadding: '0.875rem',
    messagePadding: '0.75rem',

    // Alturas específicas
    headerHeight: 'auto',
    textareaHeight: '52px',
    toggleSize: '56px',

    // Animações
    transitionDuration: '0.2s',
  },

  typography: {
    // Cabeçalho
    titleFontSize: '1.25em',
    subtitleFontSize: '0.95em',
    subtitleLineHeight: '1.6',

    // Mensagens
    messageFontSize: '0.98rem',
    messageLineHeight: '1.6',
  },
};
